export default "__VITE_ASSET__BlD3twBK__"